/**
 * Shared Navbar for public pages (HomePage, FAQs, etc.)
 * Mobile: logo left, hamburger right; nav + buttons in menu.
 * Desktop: full horizontal layout.
 */

import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LOGO_URL } from '../constants/brand'
import './HomePage.css'

const getNavLinks = (isHome) => [
  { href: isHome ? '#about' : '/#about', label: 'About Us' },
  { href: isHome ? '#benefits' : '/#benefits', label: 'Benefits' },
  { href: isHome ? '#membership' : '/#membership', label: 'Membership' },
  { href: isHome ? '#events' : '/#events', label: 'Events' },
  { to: '/faqs', label: 'FAQs', isLink: true },
]

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { pathname } = useLocation()
  const isHome = pathname === '/'
  const navLinks = getNavLinks(isHome)

  const closeMenu = () => setMenuOpen(false)

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [menuOpen])

  return (
    <nav className="home-nav">
      <div className="home-container home-nav-inner">
        <div className="home-brand">
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }} onClick={closeMenu}>
            <img src={LOGO_URL} alt="ONE Globe Alliance" className="home-brand-logo" />
          </Link>
        </div>

        <button
          type="button"
          className="home-nav-hamburger"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={menuOpen ? 'open' : ''} />
          <span className={menuOpen ? 'open' : ''} />
          <span className={menuOpen ? 'open' : ''} />
        </button>

        <div className={`home-nav-desktop ${menuOpen ? 'menu-open' : ''}`}>
          <div className="home-nav-links">
            {navLinks.map((item) =>
              item.isLink ? (
                <Link key={item.label} to={item.to} onClick={closeMenu}>{item.label}</Link>
              ) : (
                <a key={item.label} href={item.href} onClick={closeMenu}>{item.label}</a>
              )
            )}
          </div>
          <div className="home-nav-actions">
            <Link to="/register" className="home-btn home-btn-primary" onClick={closeMenu}>Register</Link>
            <Link to="/login" className="home-btn home-btn-blue" onClick={closeMenu}>Member Login</Link>
          </div>
        </div>
      </div>

      <div className={`home-nav-overlay ${menuOpen ? 'visible' : ''}`} onClick={closeMenu} aria-hidden="true" />
    </nav>
  )
}

export default Navbar
